module.exports = __webpack_public_path__ + "static/media/Escalator.462168b9.jpg";